import { Component, Input, Type, ViewChild, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Employee } from '@app/common-codes/models/matwins-tenant/Employee.model';
import { LookupProfile, LookupItem, LookupService } from '@app/common-codes/services/LookupService';
import { EmployeeDetailComponent } from '../employee-detail/employee-detail.component';
import { ReactiveBadgeComponent } from '@app/common-codes/components/nested-components/reactive-badge/reactive-badge.component';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';

@Register(Employee)
@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    ListViewComponent,
    EmployeeDetailComponent,
    ListTableColumnComponent,
    TranslatePipe,
    ReactiveBadgeComponent
  ]
})
export class EmployeeListComponent extends GenericListComponent<Employee> {

  override Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  override ComponentEntityClass = Employee;
  override entityMetaData: IEntityMetaData = new Employee().GetType();
  override contextMenuItems = [];
  modalEntity = signal<Employee | null>(null);
  @ViewChild('employeeDetail', { read: EmployeeDetailComponent }) employeeDetail!: EmployeeDetailComponent;

  employeeStatusLookup = signal<LookupItem[]>([]);
  posLookup = signal<LookupItem[]>([]);

  // Hardcoded lookups for Approve and Notify badges
  approveLookupArray: LookupItem[] = [{ id: '1', key: '1', value: 'Approve', visible: true, additionalData: { containerdisplaystate: 'containerBadge rounded success', displaystate: "badge" } }];
  notifyLookupArray: LookupItem[] = [{ id: '1', key: '1', value: 'Notify', visible: true, additionalData: { containerdisplaystate: 'containerBadge rounded info', displaystate: 'badge' } }];


  public static override get lookupProfiles(): LookupProfile[] {
    const lookupProfiles: LookupProfile[] = [
      {
        lookupName: "EmployeeStatus",
      },
      {
        lookupName: "i18nLanguage",
      },
      {
        lookupName: "PointOfService",
      },
      {
        lookupName: "Employee",
      }
    ];
    return lookupProfiles;
  }

  constructor(private _alertModalService: AlertModalService, translationService: TranslationService) {
    super();
    this.alertModalService = _alertModalService;


    effect(() => {
      const entities = this.listView()?.entities();
      if (entities) {
        // Lire la revision : si les listes arrivent en retard, l'effet repasse et les remplit.
        this.lookupService.revision();
        this.employeeStatusLookup.set(this.lookupService.getLookupData('EmployeeStatus'));
        const posData = this.lookupService.getLookupData('PointOfService')
          .map(item => ({ ...item, additionalData: { ...item.additionalData } }));
        posData.forEach(item => {
          if (!item.additionalData) item.additionalData = {};
          if (!item.additionalData['containerdisplaystate']) {
            item.additionalData['containerdisplaystate'] = 'containerBadge rounded info';
          }
          if (!item.additionalData['displaystate']) {
            item.additionalData['displaystate'] = 'badge';
          }
          item.additionalData['truckerresponsibleicon'] = '';

        });
        this.posLookup.set(posData);
      }
    });
  }

  onSearchInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm.set(value);
    this.listView()?.onSearch(value);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  override getdetailComponent(): GenetricDetailComponent<Employee> | undefined {
    return this.employeeDetail;
  }


  doSpecialAction(entity: Employee, action: string, item: any) {
    alert(` Action to do : ${action} ${entity.fullName}`);
  }
}
